import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSA = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M14.13 29.892c0 1.8 1.46 3.26 3.26 3.26h9.783c0 1.501 1.217 2.718 2.718 2.718h3.26c1.501 0 2.718-1.217 2.718-2.718v-3.26h-21.74ZM36.141 14.13v7.61a2.176 2.176 0 0 1-2.174 2.174v3.26a5.44 5.44 0 0 0 5.435-5.434v-7.61H36.14ZM12.77 21.742a2.176 2.176 0 0 1-2.173 2.174v3.26a5.441 5.441 0 0 0 5.435-5.434v-7.609H12.77v7.609Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M31.25 14.13h3.26v7.61h-3.26v-7.61ZM26.358 18.479a.544.544 0 0 1-1.087 0V14.13h-3.26v4.348a.544.544 0 0 1-1.087 0V14.13h-3.261v4.348a3.809 3.809 0 0 0 3.804 3.804c.808 0 1.557-.254 2.174-.685a3.782 3.782 0 0 0 2.654.654 2.176 2.176 0 0 1-2.11 1.661v3.261a5.441 5.441 0 0 0 5.434-5.434V14.13h-3.26v4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M17.663 23.914h4.891v3.26h-4.891v-3.26Z"
}));
FlagSA.displayName = 'FlagSA';
export default withFlagWrapper(FlagSA);
//# sourceMappingURL=index.js.map